import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { BonusInfoDesc, BorderSec } from 'src/components/Bonus';
import Intl from "./common/Intl";

function ReferralBonus61(props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <InformationWrapper>
            <BonusInfoContainer>
                <BonusInfoHeadH1><Intl langKey="PROMOTIONS@REFERRALHEAD01" /></BonusInfoHeadH1>
                <BonusInfoHeadH2><Intl langKey="PROMOTIONS@REFERRALHEAD02" /></BonusInfoHeadH2>
                <BonusInfoDesc><Intl langKey="PROMOTIONSREFERRAL@1" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSREFERRAL@2" /></BonusInfoDesc>
            </BonusInfoContainer>
            <BonusInfoContainer>
                <BonusInfoHeadH3><Intl langKey="PROMOTIONSREFERRAL@3" /></BonusInfoHeadH3>
                <BonusInfoDesc><Intl langKey="PROMOTIONSREFERRAL@4" /></BonusInfoDesc>
            </BonusInfoContainer>
            <BonusInfoContainer>
                <BonusInfoHeadH3><Intl langKey="PROMOTIONSREFERRAL@5" /></BonusInfoHeadH3>
                <BonusInfoDesc><Intl langKey="PROMOTIONSREFERRAL@6" /></BonusInfoDesc>
                <ol>
                    <li><Intl langKey="PROMOTIONSREFERRAL@7" /></li>
                    <li><Intl langKey="PROMOTIONSREFERRAL@8" /></li>
                    <li><Intl langKey="PROMOTIONSREFERRAL@9" /></li>
                    <li>
                        <BonusInfoDesc><Intl langKey="PROMOTIONSREFERRAL@10" /></BonusInfoDesc>
                        <ul>
                            <li><Intl langKey="PROMOTIONSREFERRAL@101" /></li>
                            <li><Intl langKey="PROMOTIONSREFERRAL@102" /></li>
                            <li><Intl langKey="PROMOTIONSREFERRAL@103" /></li>
                        </ul>
                    </li>
                </ol>
                <BonusInfoDesc><Intl langKey="PROMOTIONSREFERRAL@11" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSREFERRAL@12" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSREFERRAL@13" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSREFERRAL@14" /></BonusInfoDesc>
                <BonusInfoDesc><Intl langKey="PROMOTIONSREFERRAL@15" /></BonusInfoDesc>
            </BonusInfoContainer>
            <BonusInfoContainer>
                <BonusInfoHeadH3><Intl langKey="PROMOTIONSREFERRAL@16" /></BonusInfoHeadH3>
                <BonusInfoDesc><Intl langKey="PROMOTIONSREFERRAL@17" /></BonusInfoDesc>
            </BonusInfoContainer>
            <BonusInfoContainer>
                <BonusInfoHeadH3><Intl langKey="PROMOTIONSREFERRAL@18" /></BonusInfoHeadH3>
                <BonusInfoDesc><Intl langKey="PROMOTIONSREFERRAL@19" /></BonusInfoDesc>
                <ul>
                    <li><Intl langKey="PROMOTIONSREFERRAL@191" /></li>
                    <li><Intl langKey="PROMOTIONSREFERRAL@192" /></li>
                    <li><Intl langKey="PROMOTIONSREFERRAL@193" /></li>
                </ul>
            </BonusInfoContainer>
            <BonusInfoContainer>
                <BonusInfoHead><Intl langKey="PROMOTIONSREFERRAL@TERMS" /></BonusInfoHead>
                <ol>
                    <li><Intl langKey="PROMOTIONSREFERRAL@TERM1" /></li>
                    <li><Intl langKey="PROMOTIONSREFERRAL@TERM2" /></li>
                    <li><Intl langKey="PROMOTIONSREFERRAL@TERM3" /></li>
                    <li><Intl langKey="PROMOTIONSREFERRAL@TERM4" /></li>
                    <li><Intl langKey="PROMOTIONSREFERRAL@TERM5" /></li>
                    <li><Intl langKey="PROMOTIONSREFERRAL@TERM6" /></li>
                    <li><Intl langKey="PROMOTIONSREFERRAL@TERM7" /></li>
                    <li><Intl langKey="PROMOTIONSREFERRAL@TERM8" /></li>
                    <li><Intl langKey="PROMOTIONSREFERRAL@TERM9" /></li>
                    <li><Intl langKey="PROMOTIONSREFERRAL@TERM10" /></li>
                    <li><Intl langKey="PROMOTIONSREFERRAL@TERM11" /></li>
                    <li><Intl langKey="PROMOTIONSREFERRAL@TERM12" /></li>
                </ol>
            </BonusInfoContainer>
            <BonusInfoContainer>
                <BonusInfoHeadH2><Intl langKey="PROMOTIONSREFERRAL@FAQ" /></BonusInfoHeadH2>
                <BonusInfoHeadH3><Intl langKey="PROMOTIONSREFERRAL@FAQ1" /></BonusInfoHeadH3>
                <BonusInfoDesc><Intl langKey="PROMOTIONSREFERRAL@FAQAns1" /></BonusInfoDesc>
                <BonusInfoHeadH3><Intl langKey="PROMOTIONSREFERRAL@FAQ2" /></BonusInfoHeadH3>
                <BonusInfoDesc><Intl langKey="PROMOTIONSREFERRAL@FAQAns2" /></BonusInfoDesc>
            </BonusInfoContainer>
        </InformationWrapper>
    )
}

export default withTheme(withAppContext(ReferralBonus61));

// Styled Component.
const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 3rem;
    border:1px solid white;
    border-radius: 1px;
    background: rgba(111, 111, 111, 0.5);
    margin: 0em 1.2em;
    backdrop-filter: brightness(0.5);

    & ul li {
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 25px;
        text-align: justify;
        -webkit-letter-spacing: 0.01em;
        -moz-letter-spacing: 0.01em;
        -ms-letter-spacing: 0.01em;
        letter-spacing: 0.01em;
        text-transform: capitalize;
        color: #FFFFFF;
        margin: 5px 0px;
    }

    & span {
        display: flex;
        flex-direction: column; 
        right: 0px;
        width: auto;
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        text-transform: capitalize;
        color: #FFFFFF;
        align-items: flex-end;

        @media only screen and (min-width: 1700px){
            font-size: 16px;
        }
    }
`;

const BonusInfoContainer = styled.div`
   width: 100%;
   margin: auto;

   & h6 {
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.01em;
        text-transform: capitalize;
        color: #C2D2FF;
        margin: 25px 0px 20px 0px;
    }

   & h5 {
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 25px;
        text-align: justify;
        letter-spacing: 0.01em;
        text-transform: capitalize;
        color: #FFFFFF;
        margin: 5px 0px;
    }

   & ul,li {
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 25px;
        text-align: justify;
        letter-spacing: 0.01em;
        text-transform: capitalize;
        color: #FFFFFF;
    }

    & ol > li > ul > li {
        list-style-type: disc;
    }
`;

const BonusInfoHeadH2 = styled.h2`
    font-style: normal;
    font-weight: 700;
    font-size: 19px;
    line-height: 29px;
    letter-spacing: 0.01em;
    text-transform: capitalize;
    color: #E3B73E;
    margin: 15px 0px;
`;

const BonusInfoHeadH3 = styled.h3`
    font-style: normal;
    font-weight: 700;
    line-height: 29px;
    letter-spacing: 0.01em;
    text-transform: capitalize;
    color: #E3B73E;
    margin: 15px 0px;
`;

const BonusInfoHeadH1 = styled.h1`
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 29px;
    letter-spacing: 0.01em;
    text-transform: capitalize;
    color: #E3B73E;
    margin: 15px 0px;
`;

const BonusInfoHead = styled.h4`
    font-style: normal;
    font-weight: 700;
    font-size: 19px;
    line-height: 29px;
    letter-spacing: 0.01em;
    text-transform: capitalize;
    color: #E3B73E;
    margin: 15px 0px;
`;